import { render } from "./ApplicantsCounter.vue?vue&type=template&id=dacedd56&scoped=true&ts=true"
import script from "./ApplicantsCounter.vue?vue&type=script&lang=ts"
export * from "./ApplicantsCounter.vue?vue&type=script&lang=ts"

import "./ApplicantsCounter.vue?vue&type=style&index=0&id=dacedd56&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dacedd56"]])

export default __exports__